'use client';

import { GetWrapupType, WrapupModuleMapData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleMapsContinuedComponent from "./mapcontinuedcomponent";

export default class WrapupModuleMapsContinued implements IWrapupModule {
    constructor() { }

    get id(): string { return 'mapscontd'; }
    get name(): string { return 'Maps Cont.'; }

    canRender(data: GetWrapupType): boolean {
        const mapData =  (data?.data?.map as WrapupModuleMapData);
        return mapData?.mapPlays?.length > 0;
    }

    getComponentClass() {
        return WrapupModuleMapsContinuedComponent;
    }
}
